<script>
import Vue from 'vue';
import {mapState, mapGetters} from 'vuex';

export default Vue.extend({
    data() {
        return {
            collapseObject: undefined
        }
    },
    computed: {
        ...mapState({
            sites: state => state.contract.contract.item.discounts.sites
        }),
        ...mapGetters({
            getContractCollapseObject: 'contract/getContractCollapseObject'
        })
    },
    created() {
        this.collapseObject = this.getContractCollapseObject;
    },
    methods: {
        collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for(let i = 0; i < this.collapseObject[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();}, 10)
                }
            } else {
                for(let i = 0; i < this.collapseObject.length; i++) {
                    this.collapseObject[i].collapse = !(i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('site_' + obj.siteIndex).scrollIntoView();}, 10)
                }
            }
            this.$forceUpdate();
        }
    },
});
</script>
<template>
    <div class="contract-form-discount">
        <div class="contract-form-discount__content">
            <div class="contract-form-discount__header">
                <div class="contract-form-discount__heading">
                    {{ $t('contract.form.discounts.header.heading') }}
                </div>
            </div>
            <div class="contract-form-discount__body">
                <div class="contract-form-discount__items">
                    <div v-for="(site, siteIndex) in sites"
                         :id="'site_' + siteIndex"
                         :key="'site_' + siteIndex"
                         class="contract-form-discount__item contract-form-discount__item-site">
                        <div :class="{'contract-form-discount__item-header--collapsed': collapseObject[siteIndex].collapse}"
                             class="contract-form-discount__item-header" @click="collapse({siteIndex: siteIndex})">
                            {{ site.name }}
                        </div>
                        <div v-if="!collapseObject[siteIndex].collapse" >
                            <div v-for="(accommodation, accommodationIndex) in site.accommodations"
                                 :id="'accommodation_' + accommodationIndex"
                                 :key="'accommodation_' + accommodationIndex"
                                 class="contract-form-discount__item contract-form-discount__item-accommodation">
                                <div :class="{
                                         'contract-form-discount__item-label--collapsed':
                                             collapseObject[siteIndex].accommodations[accommodationIndex]
                                     }"
                                     class="contract-form-discount__item-label"
                                     @click="collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})">
                                    {{ accommodation.name }}
                                </div>
                                <div v-if="!collapseObject[siteIndex].accommodations[accommodationIndex]">
                                    <div v-for="(discount, index) in accommodation.discounts"
                                         :key="'discount_' + index"
                                         class="contract-form-discount__item contract-form-discount__accommodation-row">
                                        <div class="contract-form-discount__item-wrapper">
                                            <div class="contract-form-discount__row-item">
                                                <div class="contract-form-discount__row-label">
                                                    {{ $t('contract.form.discounts.startDate') }}
                                                </div>
                                                <template v-if="discount.discountRulePeriods.length">
                                                    <template v-for="period in discount.discountRulePeriods">
                                                        <div v-if="period.book_from"
                                                             class="contract-form-discount__item-date">
                                                            {{ period.book_from | moment('DD/MM/YYYY') }}
                                                        </div>
                                                        <div v-else
                                                             class="contract-form-discount__item-date">
                                                            {{ $t('contract.form.discounts.noDate') }}
                                                        </div>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <div class="contract-form-discount__item-date">
                                                        {{ $t('contract.form.discounts.noDate') }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="contract-form-discount__item-wrapper">
                                            <div class="contract-form-discount__row-item">
                                                <div class="contract-form-discount__row-label">
                                                    {{ $t('contract.form.discounts.endDate') }}
                                                </div>
                                                <template v-if="discount.discountRulePeriods.length">
                                                    <template v-for="period in discount.discountRulePeriods">
                                                        <div v-if="period.book_to"
                                                             class="contract-form-discount__item-date">
                                                            {{ period.book_to | moment('DD/MM/YYYY') }}
                                                        </div>
                                                        <div v-else
                                                             class="contract-form-discount__item-date">
                                                            {{ $t('contract.form.discounts.noDate') }}
                                                        </div>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <div class="contract-form-discount__item-date">
                                                        {{ $t('contract.form.discounts.noDate') }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="contract-form-discount__item-wrapper">
                                            <div :class="{'contract-form-discount__row-item--inactive': !discount.name}"
                                                 class="contract-form-discount__row-item">
                                                <div class="contract-form-discount__row-label">
                                                    {{ $t('contract.form.discounts.name') }}
                                                </div>
                                                <div v-if="discount.name"
                                                     class="contract-form-discount__item-date">
                                                    {{ discount.name }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="contract-form-discount__item-wrapper">
                                            <div class="contract-form-discount__row-item">
                                                <div class="contract-form-discount__row-label">
                                                    {{ $t('contract.form.discounts.arrivalDeparture') }}
                                                </div>
                                                <template v-if="discount.discountRulePeriods.length">
                                                    <template v-for="period in discount.discountRulePeriods">
                                                        <div v-if="period.arrival_from && period.arrival_to"
                                                             class="contract-form-discount__item-date">

                                                            <span>{{ period.arrival_from | moment('DD/MM/YYYY') }}</span>
                                                            <span>{{ period.arrival_to | moment('DD/MM/YYYY') }}</span>
                                                        </div>
                                                        <div v-else
                                                             class="contract-form-discount__item-date">
                                                            <span>{{ $t('contract.form.discounts.noDate') }}</span>
                                                            <span>{{ $t('contract.form.discounts.noDate') }}</span>
                                                        </div>
                                                    </template>
                                                </template>
                                            </div>
                                            <div v-if="discount.discountDays.length">
                                                <div v-for="(discountDay, index) in discount.discountDays"
                                                     :key="`contract-form-discount-days__${index}`">
                                                    <span v-if="discountDay.arrivalDay"
                                                          class="contract-form-discount__row-item">
                                                        {{ $t(`contract.form.discounts.day.${discountDay.arrivalDay}`) }} -
                                                    </span>
                                                    <span v-if="discountDay.departureDay"
                                                          class="contract-form-discount__row-item">
                                                        {{ $t(`contract.form.discounts.day.${discountDay.departureDay}`) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="contract-form-discount__item-wrapper">
                                            <div :class="{
                                                     'contract-form-discount__row-item--inactive': !discount.types
                                                 }"
                                                 class="contract-form-discount__row-item">
                                                <div class="contract-form-discount__row-label">
                                                    {{ $t('contract.form.discounts.types') }}
                                                </div>
                                                <div v-if="discount.types"
                                                     class="contract-form-discount__item-date">
                                                    <span v-for="(type, index) in discount.types" :key="'type_' + index">
                                                        <span v-if="type.note">
                                                            <i class="fa fa-exclamation-triangle"/>
                                                        </span>
                                                        <span :title="type.note">{{ type.type }}</span>
                                                        <span v-if="index < discount.types.length - 1">, </span>
                                                    </span>
                                                </div>
                                                <div class="contract-form-discount__row-label">
                                                    {{ $tc('contract.form.discounts.combine', discount.combinable) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sites.length === 0"
                 class="contract-form-site__no-content">
                <i class="fa fa-bullhorn"/>
                <div class="manage-allocation-list__no-content-message">
                    {{ $t('contract.form.discounts.noContent') }}
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormDiscount/ContractFormDiscount.vue